import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import {
    Cart,
    CartResult,
    updateCart as updateCartApi,
    UpdateCartApiParameter,
} from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { PunchoutCartParameter } from "@TKCCP/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    PunchoutCartParameter,
    UpdateCartApiParameter,
    CartResult,
    {
        cart: Cart;
    }
>;

export const DispatchBeginUpdateCartLine: HandlerType = props => {
    props.dispatch({
        type: "Pages/TkccpCart/BeginUpdateCart" as any,
    });
};

export const PopulateCart: HandlerType = props => {
    const state = props.getState();
    const cart = getCurrentCartState(state).value;
    if (!cart) {
        throw new Error("There was no current cart available while trying to update the current cart.");
    }

    // const poNumber = props.parameter.ponumber ?? "";
    const notes = props.parameter.notes ?? "";
    const expediteShipping = props.parameter.isExpediteShipping ?? "";
    const customerName = props.parameter.customerName ?? "";
    const properties: { [key: string]: string } = {};
    properties["cartExpediteShipping"] = expediteShipping;
    properties["CustomerName"] = customerName;

    props.cart = {
        ...cart,
        // poNumber,
        notes,
        properties,
    };
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        cart: props.cart,
    };
};

export const UpdateCart: HandlerType = async props => {
    await updateCartApi(props.apiParameter);
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const DispatchCompleteUpdateCart: HandlerType = props => {
    props.dispatch({
        type: "Pages/TkccpCart/CompleteUpdateCart" as any,
    });
};

export const chain = [
    DispatchBeginUpdateCartLine,
    PopulateCart,
    PopulateApiParameter,
    UpdateCart,
    LoadCart,
    DispatchCompleteUpdateCart,
];

const tkccpUpdateCart = createHandlerChainRunner(chain, "TkccpUpdateCart");
export default tkccpUpdateCart;
